import {
  getMemberMatchCouponList,
  getHeadquartersCouponMatch,
  normalizeHeadquartersCoupon,
} from '@/api/member/coupon'

const state = () => ({
  couponList: [],
  couponSelected: {},
  hqCouponList: [],
  hqCouponSelected: {},
})

const getters = {
  couponList: (state) => state.couponList,
  couponSelected: (state) => state.couponSelected,
  hqCouponList: (state) => state.hqCouponList,
  hqCouponSelected: (state) => state.hqCouponSelected,
}

const mutations = {
  SET_COUPON_LIST(state, couponList) {
    state.couponList = couponList
    if (couponList.length) state.couponSelected = couponList[0]
    else state.couponSelected = {}
  },
  SET_COUPON_SELECT(state, couponSelected) {
    state.couponSelected = couponSelected
  },
  SET_HQ_COUPON_LIST(state, hqCouponList) {
    state.hqCouponList = hqCouponList
    if (hqCouponList.length) state.hqCouponSelected = hqCouponList[0]
    else state.hqCouponSelected = {}
  },
  SET_HQ_COUPON_SELECT(state, hqCouponSelected) {
    state.hqCouponSelected = hqCouponSelected
  },
  REMOVE_COUPON_LIST(state) {
    state.couponList = []
    state.couponSelected = {}
    state.hqCouponList = []
    state.hqCouponSelected = {}
  },
}

const actions = {
  removeCouponList({ commit }) {
    commit('REMOVE_COUPON_LIST')
  },
  setCouponSelect({ commit }, couponSelected) {
    commit('SET_COUPON_SELECT', couponSelected)
  },
  setHqCouponSelect({ commit }, hqCouponSelected) {
    commit('SET_HQ_COUPON_SELECT', hqCouponSelected)
  },
  /**
   * 并行查询门店券与总部券，两侧状态独立，互不合并
   * 总部券：有会员、已报名且非黑名单才请求 hit
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {Object} payload
   */
  async fetchCouponList({ commit, rootGetters }, payload) {
    const { memberNum, memberCode, phone, receivableAmt, ...storePayload } = payload || {}
    const canFetchHq =
      Boolean(memberNum) &&
      rootGetters['eventBanner/registered'] === true &&
      rootGetters['eventBanner/blacklisted'] !== true
    const [storeResult, hqResult] = await Promise.allSettled([
      getMemberMatchCouponList(storePayload),
      canFetchHq
        ? getHeadquartersCouponMatch({
            memberNum,
            memberCode,
            phone,
            items: storePayload.items,
            receivableAmt,
          })
        : Promise.resolve({ data: [] }),
    ])

    if (storeResult.status === 'rejected') {
      console.error('TIPS fetchStoreCoupon error:', storeResult.reason)
    }
    if (hqResult.status === 'rejected') {
      console.error('TIPS fetchHeadquartersCoupon error:', hqResult.reason)
    }

    const storeData = storeResult.status === 'fulfilled' ? storeResult.value?.data : null
    const storeCoupons = storeData?.isCouponHitted && storeData?.coupons?.length ? storeData.coupons : []
    commit('SET_COUPON_LIST', storeCoupons)

    const hqValue = hqResult.status === 'fulfilled' ? hqResult.value : null
    const hqRawList = Array.isArray(hqValue) ? hqValue : Array.isArray(hqValue?.data) ? hqValue.data : []
    const hqCoupons = hqRawList.length
      ? hqRawList.map((item) => normalizeHeadquartersCoupon(item)).filter(Boolean)
      : []
    commit('SET_HQ_COUPON_LIST', hqCoupons)
  },
  /**
   * 仅刷新总部优惠券命中，不改动门店券
   * 有会员、已报名且非黑名单才请求 hit
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {Object} payload - { memberNum, memberCode, phone, items, receivableAmt }
   */
  async fetchHeadquartersCoupon({ commit, rootGetters }, payload) {
    const { memberNum, memberCode, phone, items, receivableAmt } = payload || {}
    const canFetchHq =
      Boolean(memberNum) &&
      rootGetters['eventBanner/registered'] === true &&
      rootGetters['eventBanner/blacklisted'] !== true
    if (!canFetchHq) {
      commit('SET_HQ_COUPON_LIST', [])
      return
    }
    try {
      const hqValue = await getHeadquartersCouponMatch({
        memberNum,
        memberCode,
        phone,
        items,
        receivableAmt,
      })
      const hqRawList = Array.isArray(hqValue) ? hqValue : Array.isArray(hqValue?.data) ? hqValue.data : []
      const hqCoupons = hqRawList.length
        ? hqRawList.map((item) => normalizeHeadquartersCoupon(item)).filter(Boolean)
        : []
      commit('SET_HQ_COUPON_LIST', hqCoupons)
    } catch (error) {
      console.error('TIPS fetchHeadquartersCoupon error:', error)
      throw error
    }
  },
}

export default { state, getters, mutations, actions }
